import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { EditAdminRequest } from '.././client-sdk/api';
import { HimmaContext } from '../Context/HimmaContext';

export const useProfileApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


   const editProfile = useCallback(
    async (id: string, data: EditAdminRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.updateMerchant(id, data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    editProfile,   
    loading,
    error, 
  };
};
